<template>
  <div class="lablist" v-if="data">
    <div class="lablist-header flex">
      <el-image
        class="lablist-header-img"
        :src="data.laboratoryLogo"
        fit="contain"
        :preview-src-list="[data.laboratoryLogo]"
      />
      <div class="lablist-header-right flex flex-column flex-between">
        <div>
          <h2>{{ data.laboratoryName }}</h2>
          <p>{{ data.laboratoryAddress }}</p>
        </div>
        <p>
          <el-link type="primary" @click="winClick"
            >实验室详情<i class="el-icon-arrow-right"></i
          ></el-link>
        </p>
      </div>
      <span
        >特色设备: <b>{{ list.length }}</b
        >台<i class="el-icon-arrow-down"></i
      ></span>
    </div>
    <div v-for="(item, index) in list" :key="index" class="flex lablist-info">
      <el-image
        class="item-img"
        :src="item.equipmentImage"
        fit="cover"
        :preview-src-list="[item.equipmentImage]"
      />
      <div class="lablist-info-right flex-1">
        <h2><i class="el-icon-star-on"></i>{{ item.equipmentName }}</h2>
        <p>
          设备型号 <span> {{ item.equipmentModel }}</span>
        </p>
        <p>
          设备编码 <span> {{ item.equipmentCode }}</span>
        </p>
        <p>
          设备品牌 <span> {{ item.equipmentBrand }}</span>
        </p>
        <p>
          主要参数 <span> {{ item.equipmentParameter }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { listForMap } from "@/api/lab";
export default {
  data() {
    return {
      list: [],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    data: {
      handler(laboratory) {
        if (laboratory) this.getList(laboratory.laboratoryId);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    winClick() {
      this.$jump.push({
        name: "labDetail",
        query: { id: this.data.laboratoryId },
      });
    },
    async getList(id) {
      const params = {
        equipmentHeatStatus: "1",
        equipmentStatus: "1",
        laborarotyId: id,
      };
      this.list = await this.$axios.post(listForMap, params);
    },
  },
};
</script>
<style lang="scss" scoped>
.lablist {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
  &-header {
    padding: 15px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    span {
      position: absolute;
      right: 0;
      bottom: 15px;
      font-size: 16px;
      b {
        color: var(--primary);
      }
    }
    &-img {
      width: 200px;
      height: 110px;
      background: #f8f8f8;
    }
    &-right {
      padding-left: 20px;

      h2 {
        font-size: 16px;
        color: var(--primary);
        margin-bottom: 10px;
      }
      p {
        color: #999;
      }
    }
  }
  &-info {
    box-shadow: 0 0 5px rgba(#333, 0.1);
    padding: 15px;
    border-radius: 12px;
    color: #999;
    margin-top: 15px;
    &-right {
      padding-left: 20px;
      h2 {
        font-size: 16px;
        color: #333;
        margin-bottom: 10px;
        i {
          color: #ff9900;
        }
      }
      p {
        margin-bottom: 5px;
      }
      span {
        color: #666;
      }
    }
  }
}
.item-img {
  width: 220px;
  height: 160px;
  border-radius: 12px;
}
</style>
